module.exports = __webpack_public_path__ + "img/purple.1a39bbc7.jpg";